<template lang="pug">
yz-filter-menu(:label="$t('price_to_patient')" :is-active="!!selectedOption" :display-value="displayValue" @clear="onClear" @apply="onApply" :disable-apply="disabledButton")
  .pa-4
    y-select.mb-2(v-model="option" :items="options" item-value="id" item-text="name" small attach)
    .d-flex.align-start
      v-icon.mx-2(size="16" color="primary") $yzi-corner-down-right
      v-text-field.round-xl(v-model="value" hide-details outlined dense placeholder="00.00" type="number" :prefix="$currency.symbol")
      template(v-if="option === 'between'")
        .text-xs.mt-3.mx-2.neutral500--text to
        v-text-field.round-xl(v-model="endValue" hide-details outlined dense placeholder="00.00" type="number" :prefix="$currency.symbol")
</template>

<script>
export default {
  props: {
    filter: { type: Object, default: () => ({}) },
    checkInitialValue: { type: Boolean, default: false }
  },
  data: () => ({
    option: 'price',
    value: null,
    endValue: null,
    options: [
      { id: 'price', name: 'Is' },
      { id: 'price__ne', name: 'Is not' },
      { id: 'price__lt', name: 'Less than' },
      { id: 'price__gt', name: 'More than' },
      { id: 'between', name: 'Is between' }
    ],
    selectedOption: null,
    selectedValue: null,
    selectedEndValue: null
  }),
  computed: {
    displayValue () {
      if (!this.selectedOption) return ''
      const opt = this.options.find(o => o.id === this.selectedOption)
      const name = opt ? opt.name : ''
      if (this.selectedOption === 'between') return `${name} ${this.selectedValue}-${this.selectedEndValue}`
      return `${name} ${this.selectedValue}`
    },
    disabledButton () {
      if (this.option === 'between' && (!this.value || !this.endValue)) return true
      return !this.value
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) this.clearData()
      }
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue && this.filter.key) {
        this.selectedOption = this.filter.key
        this.option = this.filter.key
        if (this.filter.key === 'between' && this.filter.value.length) {
          this.value = Number(this.filter.value[0].value) / Number(this.$currency.multiplier)
          this.endValue = Number(this.filter.value[1].value) / Number(this.$currency.multiplier)
          this.selectedValue = this.value
          this.selectedEndValue = this.endValue
        } else {
          this.value = Number(this.filter.value) / Number(this.$currency.multiplier)
          this.selectedValue = this.value
        }
      }
    },
    onClear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.selectedOption = null
      this.value = null
      this.endValue = null
      this.selectedValue = null
      this.selectedEndValue = null
    },
    onApply () {
      this.selectedOption = this.option
      this.selectedValue = this.value
      this.selectedEndValue = this.endValue
      let filter = { key: this.option, value: Math.round(Number(this.value) * Number(this.$currency.multiplier)) }
      if (this.option === 'between') {
        filter = {
          key: this.option,
          value: [
            { key: 'price__gte', value: Math.round(Number(this.value) * Number(this.$currency.multiplier)) },
            { key: 'price__lte', value: Math.round(Number(this.endValue) * Number(this.$currency.multiplier)) }
          ]
        }
      }
      this.$emit('update:filter', filter)
    }
  }
}
</script>
